import { LexOfficeBookingData, DatevBookingData } from './booking';
import { OcrData } from './ocr';

export type UploadedReceiptStatus =
  | 'pending'
  | 'text-extracting'
  | 'ready'
  | 'text-extraction-failed'
  | 'generation-scheduled'
  | 'generating'
  | 'generated'
  | 'generation-failed'
  | 'modified'
  | 'import-scheduled'
  | 'importing'
  | 'imported'
  | 'import-failed';

export const FINAL_STATUSES: readonly UploadedReceiptStatus[] = [
  'generated',
  'modified',
  'imported',
  'text-extraction-failed',
  'generation-failed',
  'import-failed',
];

export interface UploadedReceipt {
  id: string;
  userId: string;
  storageKey: string;
  contentType: string;
  originalFileName: string;
  fileSizeInBytes: number;
  textContent?: string;
  ocrData?: OcrData | null;
  status: UploadedReceiptStatus;
  lexOfficeBooking?: LexOfficeBookingData | null;
  datevBooking?: DatevBookingData[] | null;
  errorMessage?: string | null;
  createdAt: string;
  updatedAt: string;
}
